/**
 * Heart Outline Icon - Favorite button icon for HALO components
 *
 * Design: 16x16 outlined heart shape
 * Usage: Favorite functionality in filled brand buttons
 * Color: white for good contrast on teal backgrounds
 */

export const HeartOutlineIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.6094 2C14.0342 2.0002 16 3.93931 16 6.33008C16 8.93401 14.0556 11.3918 10.2256 13.6387L7.90332 15L5.625 13.5684C0.000272134 10.0344 7.82563e-10 7.24641 0 6.33008C0 3.9393 1.96481 2.00019 4.38965 2C5.88565 2 7.207 2.73784 8 3.86523C8.793 2.73784 10.1134 2 11.6094 2ZM11.6094 2.74023C10.4175 2.74023 9.29723 3.31768 8.61621 4.28613L8 5.16211L7.38281 4.28613C6.7018 3.31768 5.58256 2.74023 4.38965 2.74023C2.38181 2.74042 0.75 4.3506 0.75 6.33008C0.75 7.14583 0.750438 9.62831 6.02734 12.9443L7.91699 14.1318L9.8418 13.002C13.4298 10.8991 15.25 8.65389 15.25 6.33008C15.25 4.35061 13.6172 2.74043 11.6094 2.74023Z"
      fill="white"
    />
  </svg>
);
